import { Injectable, inject } from '@angular/core';

import {
    CookieName,
    CookieService,
    EventsService,
    LoyaltyLoginCoreService,
    NativeAppService,
    NativeEventType,
    OnFeatureInit,
    SimpleEvent,
    VanillaEventNames,
} from '@frontend/vanilla/core';
import { filter } from 'rxjs';

import { ValidateLoyaltyLoginRequest } from './loyalty-login.models';
import { LoyaltyLoginService } from './loyalty-login.service';

@Injectable()
export class LoyaltyLoginBootstrapService implements OnFeatureInit {
    private loyaltyLoginService = inject(LoyaltyLoginService);
    private loyaltyLoginCoreService = inject(LoyaltyLoginCoreService);
    private eventsService = inject(EventsService);
    private cookieService = inject(CookieService);
    private nativeAppService = inject(NativeAppService);

    async onFeatureInit() {
        this.loyaltyLoginCoreService.set(this.loyaltyLoginService);

        this.eventsService.events
            .pipe(filter((event: SimpleEvent) => event.eventName === VanillaEventNames.GridConnectLogin))
            .subscribe(async (event: SimpleEvent) => {
                const shopId = this.cookieService.get(CookieName.ShopId);
                const terminalId = this.cookieService.get(CookieName.TerminalId);

                if (shopId && terminalId && event.data) {
                    const request: ValidateLoyaltyLoginRequest = {
                        shopId,
                        terminalId,
                        validateLoyaltyLoginData: {
                            loginType: event.data.loginType,
                            printedTokenCode: event.data.connectCardNumber,
                            pin: event.data.pin,
                        },
                    };

                    const validation = await this.loyaltyLoginService.validate(request);

                    if (validation?.loyaltyAccountName && validation?.loyaltyCardNo) {
                        this.nativeAppService.sendToNative({
                            eventName: NativeEventType.LOYALTY_MODE_ENABLED,
                            parameters: {
                                accountName: validation.loyaltyAccountName,
                                loyaltyCardNo: validation.loyaltyCardNo,
                            },
                        });
                    }
                }
            });
    }
}
